import React from 'react';
import { BookmarkGroup } from './types';
import { formatDate } from './utils';

interface DateGroupHeaderProps {
  group: BookmarkGroup;
}

export const DateGroupHeader: React.FC<DateGroupHeaderProps> = ({ group }) => {
  const groupDateInfo = formatDate(group.bookmarks[0].createdAt);
  
  return (
    <div className="date-group-header">
      <h2 className="date-group-title">
        <span className="date-text">{groupDateInfo.dateStr}</span>
        <span className="day-text">{groupDateInfo.dayStr}</span>
      </h2>
      <div className="date-group-count">
        <span>{group.bookmarks.length} bookmark{group.bookmarks.length !== 1 ? 's' : ''}</span>
      </div>
    </div>
  );
};